export const START_FLASH = 'START_FLASH';
export const CLEAR_FLASH = 'CLEAR_FLASH';

export function flash({ status, message }) {
  return {
    type: START_FLASH,
    status,
    message
  };
}

export function clearFlash() {
  return {
    type: CLEAR_FLASH
  };
}



// WEBPACK FOOTER //
// ./js/actions/flash.js